import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { WPQTPageHeader } from "../../components/common/Header/Header";
import { UserSessionsFilter } from "../../components/Filter/UserSessionsFilter/UserSessionsFilter";
import { UserSessionsContextProvider } from "../../providers/UserSessionsContextProvider";
import { Page } from "./../Page/Page";
import { UserSessions } from "./components/UserSessions";
function UserSessionsPage() {
    return (_jsx(UserSessionsContextProvider, { children: _jsxs(Page, { children: [_jsx(WPQTPageHeader, { children: __("User sessions", "quicktasker") }), _jsx(UserSessionsFilter, {}), _jsx(UserSessions, {})] }) }));
}
export { UserSessionsPage };
